export const STORAGE_KEY_KEYBOARD_SHORTCUT_STATUS =
  'sec-keyboard-shortcut-status';
